import { z } from '@lucidlink/dto/z';
import { createDrawerCodec } from './createDrawerCodec.helper';
export const ManageGuestLinksCodec = createDrawerCodec('manageGuestLinks', [
    ['workspaceId', z.string().nonempty()],
    ['filespaceId', z.string().nonempty()],
    ['guestLinkId', z.string().nonempty()],
]);
